import React, { useState } from "react";
import {
  Header,
  Icon,
  Label,
  Table,
} from "semantic-ui-react";
import "../../components/SharedCard.css";

const EvaluationCriterionCard = ({ criterion, index }) => {
  const [showContent, setShowContent] = useState(false);
  const toggleContent = () => {
    setShowContent(!showContent);
  };

  // Parse tags from criterion
  const tags = (criterion.tags || "")
    .split(',')
    .map(t => t.trim())
    .filter(t => t && t !== 'deduction');

  return (
    <div className="custom-card" style={{ padding: 0, overflow: 'hidden', marginBottom: '1em', height: 'auto' }}>
      {/* Header Section - Clickable to expand/collapse */}
      <div 
        style={{ 
          padding: '1.5em', 
          display: 'flex', 
          alignItems: 'flex-start', 
          cursor: 'pointer', 
          width: '100%',
          backgroundColor: 'white'
        }} 
        onClick={toggleContent}
      >
        <div style={{ paddingTop: '0.2em' }}>
          <Icon 
            name={showContent ? "chevron down" : "chevron right"} 
            style={{ marginRight: '10px', color: 'grey', flexShrink: 0 }}
          />
        </div>
        
        <div style={{ flexGrow: 1, minWidth: 0 }}>
          <div style={{ marginBottom: '0.3em' }}>
            <Header as="h5" style={{ margin: 0, wordBreak: 'keep-all', lineHeight: '1.4em', color: '#1d1d1f' }}>
              <span style={{ color: 'grey', marginRight: '0.5em' }}>
                {(criterion.int_id !== null && criterion.int_id !== undefined ? criterion.int_id : index) + 1}.
              </span>
              {criterion.text}
            </Header>
          </div>
          {tags.length > 0 && (
            <div style={{ marginTop: '0.2em', fontSize: '0.85em', color: '#86868b' }}>
              {tags.map((tag, i) => (
                <span key={i} style={{ marginRight: '0.8em' }}>#{tag}</span>
              ))}
            </div>
          )}
        </div>

        <div style={{ marginLeft: '1em', flexShrink: 0, paddingTop: '0.2em' }}>
          <Label 
            circular 
            color="blue"
            size="small"
          >
            {criterion.score}
            <span style={{ opacity: 0.7, marginLeft: '2px' }}>점</span>
          </Label>
        </div>
      </div>

      {/* Expanded Content */}
      {showContent && (
        <div style={{ borderTop: '1px solid rgba(0,0,0,0.05)' }}>
          <Table basic="very" compact style={{ margin: 0, backgroundColor: '#f9fafb' }}>
            <Table.Body>
              <Table.Row>
                <Table.Cell 
                  width={3} 
                  style={{ 
                    backgroundColor: '#f0f0f5', 
                    fontWeight: '600', 
                    color: '#424245',
                    padding: '1em 1.5em',
                    verticalAlign: 'top'
                  }}
                >
                  <Icon name="tag" style={{ marginRight: '0.5em' }} />
                  평가 카테고리
                </Table.Cell>
                <Table.Cell style={{ padding: '1em 1.5em', color: '#424245' }}>
                  {criterion.tags || <span style={{ color: '#86868b' }}>없음</span>}
                </Table.Cell>
              </Table.Row>

              <Table.Row>
                <Table.Cell 
                  width={3} 
                  style={{ 
                    backgroundColor: '#f0f0f5', 
                    fontWeight: '600', 
                    color: '#424245',
                    padding: '1em 1.5em',
                    verticalAlign: 'top'
                  }}
                >
                  <Icon name="file text" style={{ marginRight: '0.5em' }} />
                  평가항목
                </Table.Cell>
                <Table.Cell style={{ padding: '1em 1.5em', color: '#424245', lineHeight: '1.5' }}>
                  {criterion.text}
                </Table.Cell>
              </Table.Row>

              <Table.Row>
                <Table.Cell 
                  width={3} 
                  style={{ 
                    backgroundColor: '#f0f0f5', 
                    fontWeight: '600', 
                    color: '#424245',
                    padding: '1em 1.5em',
                    verticalAlign: 'top'
                  }}
                >
                  <Icon name="info circle" style={{ marginRight: '0.5em' }} />
                  추가사항
                </Table.Cell>
                <Table.Cell style={{ padding: '1em 1.5em', color: '#424245', lineHeight: '1.5' }}>
                  {criterion.extra_info || <span style={{ color: '#86868b' }}>없음</span>}
                </Table.Cell>
              </Table.Row>

              <Table.Row>
                <Table.Cell
                  width={3}
                  style={{
                    backgroundColor: '#f0f0f5',
                    fontWeight: '600',
                    color: '#424245',
                    padding: '1em 1.5em',
                    verticalAlign: 'top',
                    wordBreak: 'keep-all'
                  }}
                >
                  <Icon name="lightbulb outline" style={{ marginRight: '0.5em' }} />
                  채점 노하우
                </Table.Cell>
                {/* pre-wrap: the mined know-how is a multi-line ■/- block, not a paragraph */}
                <Table.Cell style={{ padding: '1em 1.5em', color: '#424245', lineHeight: '1.5', whiteSpace: 'pre-wrap' }}>
                  {criterion.scoring_knowhow || <span style={{ color: '#86868b' }}>없음</span>}
                </Table.Cell>
              </Table.Row>

              <Table.Row>
                <Table.Cell
                  width={3}
                  style={{
                    backgroundColor: '#f0f0f5',
                    fontWeight: '600',
                    color: '#424245',
                    padding: '1em 1.5em',
                    verticalAlign: 'top'
                  }}
                >
                  <Icon name="star" style={{ marginRight: '0.5em' }} />
                  최대점수
                </Table.Cell>
                <Table.Cell style={{ padding: '1em 1.5em' }}>
                  <Label color="blue" basic>
                    {criterion.score}점
                  </Label>
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </div>
      )}
    </div>
  );
};

export default EvaluationCriterionCard;
